<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.orders.manual_checks.name')"
            is-required
            :hint="__('settings.orders.manual_checks.name_hint_group')"
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('settings.orders.manual_checks.name')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('name')"
                :invalid-feedback="errors.name"
                maxlength="191"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.active')"
            :hint="__('settings.orders.manual_checks.active_hint_group')"
        >
            <div
                role="group"
                class="form-group"
            >
                <DSwitch
                    id="switch-active"
                    v-model="form.active"
                    color="success"
                    variant="3d"
                />
            </div>
        </DFormRow>
        <DFormControls
            :cancel-route="cancelRoute"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'ManualCheckGroupForm',
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        manualCheckGroup: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.manualCheckGroup?.name ?? null,
                active: this.manualCheckGroup?.active ?? false
            })
        }
    },
    computed: {
        cancelRoute () {
            return this.$route('settings.order-manual-check-group-settings.index')
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>

<style scoped>

</style>
